module.exports = __webpack_public_path__ + "src/assets/textures/env/water_tower/water_tower_1k_bake.png";